import LookupsContainer from './LookupsContainer';
export default LookupsContainer;
